import { render } from "./participants-list-card.vue?vue&type=template&id=8ca4e726"
import script from "./participants-list-card.vue?vue&type=script&lang=js"
export * from "./participants-list-card.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__